// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Toggle_wrapper_3tEZy","slider":"Toggle_slider_lVjy2","lock":"Toggle_lock_2kjVX","active":"Toggle_active_1FshI"};